// extracted by mini-css-extract-plugin
export default {"productSwitch":"ProductSwitch_productSwitch__hql8R","textInverse":"ProductSwitch_textInverse__tXdvy"};